import api from "./axios";

export const addTaskApi = (leadId, payload) =>
  api.post(`/leads/${leadId}/tasks`, payload);

export const updateTaskApi = (leadId, taskId, payload) =>
  api.put(`/leads/${leadId}/tasks/${taskId}`, payload);

export const deleteTaskApi = (leadId, taskId) =>
  api.delete(`/leads/${leadId}/tasks/${taskId}`);
